// import axios from "axios";
import axios from "../../axiosConfig";
import { call, put } from "redux-saga/effects";
import { EXPORT_IMPS_FAILED, EXPORT_IMPS_SUCCESS, GET_IMPS_FAILED, GET_IMPS_SUCCESS } from "../Actions/AdsImpressionsActions";
import { TOAST_SHOW } from "../Actions/ToastAction";

import FileDownload from 'js-file-download';

export function* GetCImpSaga(action: any): unknown {

    try {
        const { hour, searchBy, search} = action.payload
        const response = yield call(axios.get, `getCImps?hour=${hour}&searchBy=${searchBy}&search=${search}`);
        yield put({ type: GET_IMPS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: GET_IMPS_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}

export function* exportCIMPDataSaga(action: any): unknown {
    try {
        const { hour, searchBy, search } = action.payload
        const response = yield call(axios.get, `/getCimpDataCSV?hour=${hour}&searchBy=${searchBy}&search=${search}`);

        const { data, status } = response

        if (status === 200) {
            yield put({ type: EXPORT_IMPS_SUCCESS });
            FileDownload(data, `cimp_data.csv`);
        }

    } catch (e: any) {
        yield put({ type: EXPORT_IMPS_FAILED });
        yield put({
            type: TOAST_SHOW,
            payload: { message: 'Something went wrong!', severity: 'Danger', show: true },
        });
    }
}